module.exports = __webpack_public_path__ + "assets/img/bdc9-ic.svg";